import { Quiz as QuizType } from "@platform/types/quiz.types";
import { PanelTitle } from "@shared/ui/PanelTitle";
import { QuizQuestionSet as QuizQuestionSetComponent } from "../QuizQuestionSet/QuizQuestionSet";
import { useQuizProps } from "./useQuizProps";

type Props = {
  quizResponseId: number;
  quiz: QuizType | undefined;
  onCompleteQuiz: () => void;
};

export function Quiz({ quiz, quizResponseId, onCompleteQuiz }: Props) {
  const {
    activeQuestionSet,
    buttonLabel,
    filterQuestionSet,
    handleNextQuestionObject,
    handlePreviousQuestionObject,
    isSubmitting,
    title,
    description,
    formData,
    stepIndex,
    totalSteps,
  } = useQuizProps({
    quiz,
    quizResponseId,
    onCompleteQuiz,
  });

  return (
    <>
      <PanelTitle
        title={title}
        description={description}
        className="py-4 z-10 overflow-hidden"
        innerClassName="px-4 py-0"
      />
      <QuizQuestionSetComponent
        questionSet={activeQuestionSet}
        filterQuestionSet={filterQuestionSet}
        buttonLabel={buttonLabel}
        onSubmit={handleNextQuestionObject}
        onBack={handlePreviousQuestionObject}
        isSubmitting={isSubmitting}
        defaultValues={formData}
        stepIndex={stepIndex}
        totalSteps={totalSteps}
      />
    </>
  );
}

export default Quiz;
